<template>
  <div id="custom-table-list" class="custom-table-container">
    <campaign-banner-view-sidebar
      v-if="sidebarData.id !== undefined"
      :isSidebarActive="addNewDataSidebar"
      @closeSidebar="toggleDataSidebar"
      @refreshList="fetchData"
      :campaignBanner="sidebarData"
    />

    <campaign-banner-view-sidebar
      v-else
      :isSidebarActive="addNewDataSidebar"
      @closeSidebar="toggleDataSidebar"
      @refreshList="fetchData"
    />

    <vs-table
      ref="table"
      :sst="true"
      @sort="handleSort"
      @search="handleSearch"
      noDataText="Sem dados disponíveis"
      search
      :data="campaignBanners"
    >
      <!-- HEADER -->
      <div slot="header" id="custom-header-wrapper">
        <HeaderList
          :itemsPerPage="itemsPerPage"
          @changeItemsPerPage="setItemsPerPage"
          @emitAddNewData="addNewData"
        />
      </div>
      <!-- FIM HEADER -->

      <template slot="thead">
        <vs-th>Imagem</vs-th>
        <vs-th sort-key="title">Título</vs-th>
        <vs-th sort-key="position">Posição</vs-th>
        <vs-th sort-key="clicks">Clicks</vs-th>
        <vs-th>Criada Em</vs-th>
        <vs-th>Atualizada Em</vs-th>
        <vs-th>Ativo</vs-th>
        <vs-th>Ações</vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

            <vs-td class="whitespace-no-wrap">
              <a :href="tr.image_url" target="_blank">
                <img :src="tr.image_url" alt="" :title="tr.image_url" width="64" />
              </a>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium">{{ tr.title }}</p>
              <p><small>{{ tr.description }}</small></p>
            </vs-td>

            <vs-td>
              <p class="product-position font-medium">
                {{ tr.position ? `${tr.position}º` : '' }}
              </p>
            </vs-td>

            <vs-td>
              <p class="product-position font-medium">
                {{ tr.clicks_qty }}
              </p>
            </vs-td>

            <vs-td>
              <p class="font-medium">
                {{ formatStringDate(tr.created_at) }}
              </p>
            </vs-td>

            <vs-td>
              <p class="font-medium">
                {{ formatStringDate(tr.updated_at) }}
              </p>
            </vs-td>

            <vs-td>
              <p class="product-activated font-medium">
                <ActiveItem :active="tr.activated" />
              </p>
            </vs-td>

            <vs-td class="whitespace-no-wrap">
              <feather-icon
                icon="EditIcon"
                svgClasses="w-5 h-5 mr-2 hover:text-primary stroke-current"
                @click.stop="editData(tr)"
              />

              <a :href="tr.destination_url" target="_blank" v-if="tr.destination_url" title="Ir ao destino da campanha">
                <feather-icon
                  icon="ExternalLinkIcon"
                  svgClasses="w-5 h-5 hover:text-primary stroke-current"
                />
              </a>
              <feather-icon
                v-else
                icon="ExternalLinkIcon"
                svgClasses="w-5 h-5 stroke-current"
                title="Campanha sem destino"
                style="color: #ccc"
              />
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>

    <vs-pagination :total="totalPages" v-model="currentPage"></vs-pagination>
  </div>
</template>

<script>
  import ActiveItem from '@/components/ActiveItem'
  import CampaignBannerViewSidebar from './CampaignBannerViewSidebar'
  import HeaderList from '@/views/components/custom/HeaderList'

  import moduleCampaignBanner from '@/store/campaign-banner/moduleCampaignBanner'
  import { defineSortFieldDirection, formatDate  } from '@/utils'

  export default {
    name: 'campaign-banners-list',
    components: {
      CampaignBannerViewSidebar,
      ActiveItem,
      HeaderList
    },
    data() {
      return {
        itemsPerPage: 5,
        currentPage: 1,
        isMounted: false,
        addNewDataSidebar: false,
        sidebarData: {},
        searchField: null,
        sortField: {
          default: 'id_desc',
          current: '',
          count: 0
        }
      }
    },
    computed: {
      campaignBanners() {
        return this.$store.state.campaignBanners.campaignBanners
      },
      totalPages() {
        return this.$store.state.campaignBanners.totalPages
      }
    },
    watch: {
      currentPage() {
        this.handleChangePage()
      },
      itemsPerPage() {
        this.handleChangePage()
      }
    },
    methods: {
      addNewData() {
        this.sidebarData = {}
        this.toggleDataSidebar(true)
      },
      editData(data) {
        this.sidebarData = this.$_.cloneDeep(data)
        this.toggleDataSidebar(true)
      },
      toggleDataSidebar(val=false) {
        this.addNewDataSidebar = val

        if (val === false) {
          this.sidebarData.id = null
          this.$store.dispatch("campaignBanners/resetChosenBanner")
        }
      },
      setItemsPerPage(qty) {
        this.currentPage = 1
        this.itemsPerPage = qty
        //this.fetchData()
      },
      handleSort(sort) {
        if (sort !== null) {
          this.sortField.count++

          if (this.sortField.count < 3) {
            this.sortField.current = defineSortFieldDirection(this.sortField.current, sort)
          } else {
            this.resetSortField()
          }
          
          this.fetchData()
        } else {
          if (this.sortField.current !== this.sortField.default) {
            this.resetSortField()
            this.fetchData()
          }
        }
      },
      resetSortField() {
        this.sortField.current = this.sortField.default;
        this.sortField.count = 0;
      },
      handleSearch(search) {
        let searchField = null

        if (search !== "") {
          searchField = {
            title: search
          }
        }
        
        this.searchField = searchField
        this.fetchData()
      },
      handleChangePage() {
        this.fetchData()
      },
      fetchData() {
        if (moduleCampaignBanner.isRegistered) {
          this.$store.dispatch("campaignBanners/fetch", {
            ...this.searchField, 
            ...{ order_by: this.sortField.current },
            ...{ pagination_page: this.currentPage, pagination_limit: this.itemsPerPage }
          })
        }
      },
      formatStringDate(date) {
        return formatDate(date).full
      }
    },
    created() {
      this.resetSortField();

      if (!moduleCampaignBanner.isRegistered) {
        this.$store.registerModule('campaignBanners', moduleCampaignBanner)
        moduleCampaignBanner.isRegistered = true
      }
      
      this.fetchData()
      this.$store.dispatch("campaignBanners/listenToSocket", this.$store.state.AppActiveUser.id)
      this.$store.dispatch("campaignBanners/lastNews")
    },
    mounted() {
      this.isMounted = true;
    }
  }
</script>